import React from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../hooks/useSEO';

const NotFoundPage: React.FC = () => {
  useSEO({
    title: 'Pagina niet gevonden | WFT Study Buddy',
    description: 'De pagina die je zoekt bestaat niet of is verplaatst. Bekijk onze WFT examens, kennisbank of neem contact op.',
    canonicalUrl: '/404'
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center px-4">
      <div className="max-w-lg text-center">
        <h1 className="text-8xl font-bold text-blue-600 mb-4">404</h1>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Pagina niet gevonden
        </h2>
        <p className="text-gray-600 mb-8">
          De pagina die je zoekt bestaat niet of is verplaatst.
          Gebruik een van de links hieronder om verder te gaan.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
          <Link
            to="/"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
          >
            Naar homepage
          </Link>
          <Link
            to="/wft-examens"
            className="bg-white text-blue-600 border-2 border-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 transition"
          >
            WFT Examens
          </Link>
          <Link
            to="/informatie"
            className="bg-white text-blue-600 border-2 border-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 transition"
          >
            Kennisbank
          </Link>
          <Link
            to="/faq"
            className="bg-white text-blue-600 border-2 border-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 transition"
          >
            Veelgestelde vragen
          </Link>
        </div>

        <p className="text-sm text-gray-500">
          Hulp nodig? <Link to="/contact" className="text-blue-600 hover:underline">Neem contact op</Link>
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
